import { render } from "./TokenHeader.vue?vue&type=template&id=320101cb&scoped=true"
import script from "./TokenHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenHeader.vue?vue&type=script&setup=true&lang=js"

import "./TokenHeader.vue?vue&type=style&index=0&id=320101cb&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320101cb"],['__file',"resources/js/components/TokenHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "320101cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('320101cb', __exports__)) {
    api.reload('320101cb', __exports__)
  }
  
  module.hot.accept("./TokenHeader.vue?vue&type=template&id=320101cb&scoped=true", () => {
    api.rerender('320101cb', render)
  })

}


export default __exports__